import { Modal, Button } from 'hljd'
import style from './index.module.less'
import React from 'react'
import { observer } from 'mobx-react'

export default observer(({ store }) => {
  const {
    betterCases,
    betterModalStatus,
    triggerBetterModal,
    neverMind
  } = store

  const goPreview = id => {
    window.open(
      `/p/wedding/Public/admin/local_merchant_react/dist/index.html#/localMerchant/businessSchool/${id}`
    )
  }

  return (
    <Modal
      title={<div style={{ fontWeight: 'bold', fontSize: 14 }}>直播推荐</div>}
      visible={betterModalStatus}
      width={380}
      height={267}
      centered={true}
      onCancel={triggerBetterModal}
      maskClosable={false}
      footer={
        <div>
          <Button
            className={style.cancelBtn}
            type="default"
            onClick={neverMind}
          >
            不再提醒
          </Button>
          <Button
            className={style.btn}
            type="primary"
            onClick={triggerBetterModal}
          >
            确定
          </Button>
        </div>
      }
    >
      <div className={style.betterModal}>
        <div className={style.title}>最新视频直播资讯都为你整理好了！</div>

        <div>
          {betterCases.map(b => (
            <a
              className={style.content}
              key={b.id}
              onClick={() => goPreview(b.id)}
            >
              《{b.title}》
            </a>
          ))}
        </div>
      </div>
    </Modal>
  )
})
